//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import shopStockInBuyOrderManager from "@/Manager/04.Sms/ShopStockInBuyOrderManager";
export default {
  props: ["controlItem"],
  components: {},
  data() {
    return {
      mobile: "",
      sms: "",
      err: "",
      show: true,
      count: "",
      phoneRegex: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
      cellList: [
        {
          title: "会员编号：",
          value: ""
        },
        {
          title: "所属门店：",
          value: ""
        },
        {
          title: "积分余量：",
          value: ""
        }
      ]
    };
  },
  methods: {
    searchPesole() {
      if (!this.phoneRegex.test(this.mobile))
        return this.$msg.alert("请输入正确的手机号码");
      if (this.isVcodeSend) return;
      if (
        this.controlItem.ControlUrl.QueryUrl == "" ||
        this.controlItem.ControlUrl.QueryUrl == null
      ) {
        this.$msg.alert("找不到相关的Url");
        return;
      }

      var url = this.controlItem.ControlUrl.QueryUrl;
      sessionStorage.setItem("QueryUrl", url);

      this.$msg.showLoading();
      var opneId = this.controlItem.OpenId;
      var tplPostData = this.$parent.getSubmitData();
      tplPostData["Phone"] = this.mobile;

      shopStockInBuyOrderManager.SearchInformation(tplPostData).then(result => {
        this.$msg.hideLoading();
      });
    }
  },
  created() {},

  mounted() {}
};
